import { jsx as m } from "react/jsx-runtime";
import { c as o } from "../../index-2QXL0WYc.js";
import { DividerCssClass as s } from "./Divider.types.js";
const p = ({
  className: a,
  gutter: r,
  vertical: e,
  ...i
}) => /* @__PURE__ */ m(
  "hr",
  {
    className: o(a, s.Base, {
      [`${s.Gutter}--${r}`]: r,
      [s.Vertical]: e
    }),
    ...i
  }
);
export {
  p as IressDivider
};
